'use strict';

/**
 * These functions are `async`, so their continuations run outside a `$digest`. A caller that
 * mutates `$scope` after awaiting one needs a digest of its own — the profile panels get theirs
 * from the `$scope.$apply()` in the directive's `save()`.
 */
angular.module('ClinicApp').factory('FinancingOptionService', function($http, ClinicConfig) {
  return {
    /**
     * Lists the financing options any clinic can offer.
     */
    listAvailable: async () => {
      const { data } = await $http.get(`${ClinicConfig.HOSTNAME}/clinic/financingOption`);

      return data;
    },

    /**
     * Lists the financing options a clinic already offers.
     */
    listForClinic: async (clinicId) => {
      const { data } = await $http.get(`${ClinicConfig.HOSTNAME}/clinic/${clinicId}/financingOption`);

      return data;
    },

    /**
     * Replaces the whole set of financing options a clinic offers. An empty list clears it.
     *
     * @param {Number} clinicId
     * @param {Array} financingOptionIds
     */
    updateForClinic: async (clinicId, financingOptionIds) => {
      const { data } = await $http.put(
        `${ClinicConfig.HOSTNAME}/clinic/${clinicId}/financingOption`,
        { financingOptionIds },
      );

      return data;
    },
  };
});
